import React, { useId } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./phoneNumberInput.css";
import {
  DEFAULT_COUNTRY_CODE,
  DEFAULT_COUNTRY_ISO,
  PREFERRED_COUNTRY_ISOS,
  isBlankPhoneValue,
  sanitizePhoneValue,
  toPhoneInputValue,
} from "../../utils/phoneNumberUtils";

const PhoneNumberInput = ({
  value,
  onChange,
  onBlur,
  disabled = false,
  hasError = false,
  placeholder,
  id: idProp,
  describedBy,
  inputProps = {},
}) => {
  const generatedId = useId();
  const inputId = idProp || generatedId;

  const handleChange = (phone, country) => {
    const dialCode = country?.dialCode || DEFAULT_COUNTRY_CODE;
    if (isBlankPhoneValue(phone, dialCode)) {
      onChange?.("");
      return;
    }
    onChange?.(sanitizePhoneValue(phone));
  };

  return (
    <PhoneInput
      defaultCountry={DEFAULT_COUNTRY_ISO}
      preferredCountries={PREFERRED_COUNTRY_ISOS}
      value={toPhoneInputValue(value)}
      onChange={handleChange}
      onBlur={onBlur}
      disabled={disabled}
      enableSearch
      enableAreaCodes={false}
      countryCodeEditable={false}
      autoFormat
      placeholder={placeholder}
      dropdownClass="cc-phone-input__dropdown"
      containerClass={`cc-phone-input${hasError ? " cc-phone-input--error" : ""}${
        disabled ? " cc-phone-input--disabled" : ""
      }`}
      inputProps={{
        id: inputId,
        name: inputProps.name,
        required: inputProps.required,
        "aria-invalid": hasError || undefined,
        "aria-describedby": describedBy,
        autoComplete: "tel",
        ...inputProps,
      }}
    />
  );
};

export default PhoneNumberInput;
